<script lang="ts">
  import { onMount } from "svelte";
  import UIRouterLink from "@shared/svelte/Components/UIRouterLink.svelte";
  import FormatMoney from "@shared/svelte/Components/FormatMoney.svelte";
  import ProductContainerDetails from "@shared/filters/product_container_details.js";
  import DealsCartWidgetContainer from "@retailer/svelte/CartWidget/v2/Containers/DealsCartWidgetContainer.svelte";
  import { DealTierProductEntity } from "@shared/services/event_tracking/entities";
  import { InventoryItemStore } from "@retailer/svelte/CartWidget/v2/Stores/InventoryItemStore";

  import type { HappyHourDealProduct } from "@shared/types/Deals";

  export let product: HappyHourDealProduct;
  export let distributorId: number;
  export let productGroupId: string;
  export let dealActive: boolean = true;
  export let isRip: boolean = false;

  let inventoryItemLoaded: boolean = false;

  onMount(async () => {
    inventoryItemLoaded = false;
    const response = await InventoryItemStore.fetchInventoryItem(product.inventory_id);
    inventoryItemLoaded = response?.loaded;
  });

  const trackingEntities = [
    new DealTierProductEntity({
      product_id: product.product_id,
      deal_tier_id: null,
      distributor_id: distributorId,
      product_group_id: productGroupId,
      sku: product.sku,
    }),
  ];

  $: unitDiscountValue = product.discount.discountValue?.unitValue;
  $: caseDiscountValue = product.discount.discountValue?.caseValue;
  $: productContainerDetails = ProductContainerDetails()(product, null, null, true);
</script>

<style>
  .table-cart-widget-cell {
    padding: 0 0.75rem 1rem !important;
    vertical-align: top;
  }
</style>

<tr data-testid="deal-product-row-{product.sku}">
  <td>
    <div>
      <UIRouterLink
        stateName="layout.product_detail"
        params={{ productId: product.product_line_id }}
      >
        <strong>{product.product_line_name}</strong>
      </UIRouterLink>
      <br />
      <p>
        {productContainerDetails}
      </p>
      <p class="fizz-text-small">
        SKU: {product.sku}
      </p>
    </div>
  </td>

  <td data-label="List Price">
    <div>
      {#if product.frontlinePrice.unitPrice}
        <p>
          <FormatMoney input={product.frontlinePrice.unitPrice} />/{product.container_type}
        </p>
      {/if}
      {#if product.frontlinePrice.casePrice}
        <p>
          <FormatMoney input={product.frontlinePrice.casePrice} />/case
        </p>
      {/if}
    </div>
  </td>

  {#if !isRip}
    <td data-label="Deal Price">
      <div>
        {#if unitDiscountValue}
          <p data-testid="deal-price-unit-{product.sku}">
            <FormatMoney
              input={product.frontlinePrice.unitPrice - unitDiscountValue}
            />/{product.container_type}
            <span class="fizz-text-small fizz-text-deal fizz-nowrap">
              <s class="fizz-text-subdued">
                <FormatMoney input={product.frontlinePrice.unitPrice} />
              </s>
              (<FormatMoney input={unitDiscountValue} /> off)
            </span>
          </p>
        {/if}
        {#if caseDiscountValue}
          <p data-testid="deal-price-case-{product.sku}">
            <FormatMoney input={product.frontlinePrice.casePrice - caseDiscountValue} />/case
            <span class="fizz-text-small fizz-text-deal fizz-nowrap">
              <s class="fizz-text-subdued">
                <FormatMoney input={product.frontlinePrice.casePrice} />
              </s>
              (<FormatMoney input={caseDiscountValue} /> off)
            </span>
          </p>
        {/if}
      </div>
    </td>
  {/if}

  {#if dealActive}
    <td class="table-cart-widget-cell">
      <DealsCartWidgetContainer
        inventoryId={product.inventory_id}
        {trackingEntities}
        loaded={inventoryItemLoaded}
      />
    </td>
  {/if}
</tr>
